import React from 'react'
import {
  Flex,
  FlexItem,
  Title,
  SpacingVertical,
  GridCell,
  Grid,
  FormElement,
  Text,
  Divider
} from 'mailup-web-components'
import styled from '@emotion/styled'
import iconTheme from '../../icons/cd-icon-theme.svg'
import { useIntl } from 'react-intl'
import ThemeSelect from 'Pages/EmailContentDefaults/shared/ThemeSelect'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import {
  pageState,
  styleState
} from 'Pages/EmailContentDefaults/recoil/state/state'
import {
  DEFAULT_THEME,
  SOCIAL_LIST
} from 'Pages/EmailContentDefaults/shared/utils'

const StyleGrid = styled(Grid)`
  margin: 0 12px;
`
const StyledIcon = styled.img`
  width: 24px;
  height: 24px;
  padding-right: 8px;
`

const SocialIconTheme = () => {
  const setPageState = useSetRecoilState(pageState)
  const setStyleState = useSetRecoilState(styleState)
  const { isEnabled } = useRecoilValue(pageState)
  const { social } = useRecoilValue(styleState)
  const intl = useIntl()

  const onChangeTheme = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      social: {
        ...prev.social,
        icons: prev.social.icons.map(m => ({
          ...m,
          type: value,

          image: {
            ...m.image,
            src: SOCIAL_LIST.find(f => f.name === m.name).image.src.replace(
              '@@@replace@@@',
              value
            )
          }
        }))
      }
    }))
  }

  return (
    <>
      <Flex alignItems='center'>
        <StyledIcon src={iconTheme} />
        <Title variant='M'>
          {intl.formatMessage({
            id: 'Load.ContentDefaults.CommonThemesTitle'
          })}
        </Title>
      </Flex>
      <SpacingVertical variant='16' />
      <StyleGrid cols={12}>
        <GridCell span={4}>
          <FormElement
            label={intl.formatMessage({
              id: 'Load.ContentDefaults.SocialThemeLabel'
            })}
          >
            <ThemeSelect
              value={
                social.icons.length > 0 ? social.icons[0].type : DEFAULT_THEME
              }
              onChange={onChangeTheme}
              disabled={!isEnabled || social.icons.length === 0}
            />
          </FormElement>
        </GridCell>
      </StyleGrid>
      <SpacingVertical />
      <Divider />
      <SpacingVertical />
    </>
  )
}

export default SocialIconTheme
